import React from "react";
import PropTypes from "prop-types";

import Loader from "./Loader";

const LoadingPlaceholder = ({ loading, children }) =>
  loading ? <Loader/> : children();

LoadingPlaceholder.defaultProps = {
  loading: true,
  children: () => {}
};

LoadingPlaceholder.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.func
};

export default LoadingPlaceholder;
